"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoinSelect = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const lodash_1 = require("lodash");
const errors_1 = require("@ledgerhq/errors");
const types_1 = require("./types");
const utils = __importStar(require("../utils"));
const DeepFirst_1 = require("./DeepFirst");
const logs_1 = require("@ledgerhq/logs");
class CoinSelect extends types_1.PickingStrategy {
    selectUnspentUtxosToUse(xpub, outputs, feePerByte) {
        return __awaiter(this, void 0, void 0, function* () {
            // get the utxos to use as input
            // from all addresses of the account
            const addresses = yield xpub.getXpubAddresses();
            (0, logs_1.log)("picking strategy", "Coinselect");
            const unspentUtxos = (0, lodash_1.flatten)(yield Promise.all(addresses.map(address => xpub.storage.getAddressUnspentUtxos(address)))).filter(o => !this.excludedUTXOs.filter(x => x.hash === o.output_hash && x.outputIndex === o.output_index).length);
            const TOTAL_TRIES = 100000;
            (0, logs_1.log)("picking strategy", "utxos", unspentUtxos);
            // Compute cost of change
            const fixedSize = utils.maxTxSize(0, [], false, this.crypto, this.derivationMode);
            const outputScripts = outputs.map(o => o.script);
            // Size of only 1 output (without fixed size)
            const oneOutputSize = outputScripts.length > 0
                ? utils.maxTxSize(0, [outputScripts[0]], false, this.crypto, this.derivationMode) -
                    fixedSize
                : utils.maxTxSize(0, [], true, this.crypto, this.derivationMode) - fixedSize;
            // Size 1 signed UTXO (signed input)
            const oneInputSize = utils.maxTxSize(1, [], false, this.crypto, this.derivationMode) - fixedSize;
            // Calculate effective value of outputs
            let currentAvailableValue = 0;
            let effectiveUtxos = [];
            for (let i = 0; i < unspentUtxos.length; i += 1) {
                const outEffectiveValue = Number(unspentUtxos[i].value) - feePerByte * oneInputSize;
                if (outEffectiveValue > 0) {
                    const effectiveUtxo = {
                        index: i,
                        effectiveValue: outEffectiveValue,
                    };
                    effectiveUtxos.push(effectiveUtxo);
                    currentAvailableValue += outEffectiveValue;
                }
            }
            // Get no inputs fees
            // At beginning, there are no outputs in tx, so noInputFees are fixed fees
            const notInputFees = feePerByte * (fixedSize + oneOutputSize * outputs.length);
            // Start coin selection algorithm (according to SelectCoinBnb from Bitcoin Core)
            let currentValue = 0;
            const currentSelection = [];
            const amount = outputs.reduce((sum, output) => sum.plus(output.value), new bignumber_js_1.default(0));
            // Actual amount we are targetting
            const actualTarget = notInputFees + amount.toNumber();
            // Insufficient funds
            if (currentAvailableValue < actualTarget) {
                throw new errors_1.NotEnoughBalance();
            }
            // Sort utxos by effectiveValue
            effectiveUtxos = (0, lodash_1.sortBy)(effectiveUtxos, "effectiveValue");
            effectiveUtxos = effectiveUtxos.reverse();
            let currentWaste = 0;
            let bestWaste = Number.MAX_SAFE_INTEGER;
            let bestSelection = [];
            // Dfs to find a solution with minimal fees
            let bestSelectionNeedChangeoutput = false;
            let currentSelectionNeedChangeoutput = false;
            for (let i = 0; i < TOTAL_TRIES; i += 1) {
                let backtrack = false;
                const nbInput = currentSelection.filter(x => x).length;
                if (currentValue >= actualTarget) {
                    if (currentValue - actualTarget > feePerByte * oneOutputSize) {
                        // changeoutput is required
                        currentSelectionNeedChangeoutput = true;
                        currentWaste =
                            feePerByte *
                                utils.maxTxSizeCeil(nbInput, outputScripts, true, this.crypto, this.derivationMode);
                    }
                    else {
                        // changeoutput is not required
                        currentSelectionNeedChangeoutput = false;
                        currentWaste =
                            feePerByte *
                                utils.maxTxSizeCeil(nbInput, outputScripts, false, this.crypto, this.derivationMode) +
                                currentValue -
                                actualTarget;
                    }
                    if (currentWaste <= bestWaste) {
                        bestSelection = currentSelection.slice();
                        while (effectiveUtxos.length > bestSelection.length) {
                            bestSelection.push(false);
                        }
                        bestSelection.length = effectiveUtxos.length;
                        bestWaste = currentWaste;
                        bestSelectionNeedChangeoutput = currentSelectionNeedChangeoutput;
                    }
                    backtrack = true;
                }
                if (currentSelection.length >= effectiveUtxos.length) {
                    backtrack = true;
                }
                // Move backwards
                if (backtrack) {
                    while (currentSelection.length > 0 && !currentSelection[currentSelection.length - 1]) {
                        currentSelection.pop();
                    }
                    // Case we walked back to the first utxos and all solutions searched.
                    if (currentSelection.length === 0) {
                        break;
                    }
                    currentSelection[currentSelection.length - 1] = false;
                    const eu = effectiveUtxos[currentSelection.length - 1];
                    currentValue -= eu.effectiveValue;
                }
                else {
                    // Moving forwards, continuing down this branch
                    const eu = effectiveUtxos[currentSelection.length];
                    currentSelection.push(true);
                    currentValue += eu.effectiveValue;
                }
            }
            // solution found
            if (bestSelection.length > 0) {
                let total = new bignumber_js_1.default(0);
                const unspentUtxoSelected = [];
                for (let i = 0; i < bestSelection.length; i += 1) {
                    if (bestSelection[i]) {
                        unspentUtxoSelected.push(unspentUtxos[effectiveUtxos[i].index]);
                        total = total.plus(unspentUtxos[effectiveUtxos[i].index].value);
                    }
                }
                const fee = feePerByte *
                    utils.maxTxSizeCeil(unspentUtxoSelected.length, outputScripts, bestSelectionNeedChangeoutput, this.crypto, this.derivationMode);
                return {
                    totalValue: total,
                    unspentUtxos: unspentUtxoSelected,
                    fee: Math.ceil(fee),
                    needChangeoutput: bestSelectionNeedChangeoutput,
                };
            }
            const pickingStrategy = new DeepFirst_1.DeepFirst(this.crypto, this.derivationMode, this.excludedUTXOs);
            return pickingStrategy.selectUnspentUtxosToUse(xpub, outputs, feePerByte);
        });
    }
}
exports.CoinSelect = CoinSelect;
//# sourceMappingURL=CoinSelect.js.map